import { useEffect } from 'react';

import { useFastshiftAnalyticsData, useFireAnalyticsEvents } from '@/analytics';
import { ActionKey, ActionSubjectKey, ActionSubjectIdKey } from '@/analytics/constants';
import { useFastshiftSelector } from '@/state';
import { TABLE_IDS } from '@/state/constants';

export const useMigrationTicketsPageAnalytics = () => {
	const { sourceKey, identityAttrs } = useFastshiftAnalyticsData();
	const { fireScreenEvent, fireTrackEvent } = useFireAnalyticsEvents(identityAttrs);
	const { data: supportRequestsData } = useFastshiftSelector((state) => state.supportRequests);

	const cachedTableControls = useFastshiftSelector(
		(state) => state.pageStateCache[TABLE_IDS.MIGRATION_TICKETS],
	);

	// Screen event on mount
	useEffect(() => {
		if (!identityAttrs) return;

		fireScreenEvent({
			name: sourceKey,
		});
	}, [fireScreenEvent, sourceKey, identityAttrs]);

	// Track event when page data loads or pagination changes
	useEffect(() => {
		if (!identityAttrs || !supportRequestsData) {
			return;
		}

		const planTicketList = supportRequestsData
			.slice(
				cachedTableControls.page * cachedTableControls.size,
				(cachedTableControls.page + 1) * cachedTableControls.size,
			)
			.map((ticket) => ticket.supportTicketId);

		fireTrackEvent({
			action: ActionKey.DISPLAYED,
			actionSubject: ActionSubjectKey.SECTION,
			actionSubjectId: ActionSubjectIdKey.MIGRATION_TICKETS_PAGE_DETAILS,
			source: sourceKey,
			attributes: {
				planTicketCount: planTicketList.length,
				planTicketList,
			},
		});
	}, [
		identityAttrs,
		supportRequestsData,
		cachedTableControls.page,
		cachedTableControls.size,
		fireTrackEvent,
		sourceKey,
	]);
};
